export { default as Credits } from "./IndexPage/Credits.vue";
export { default as CreditDetails } from "./DetailsPage/Detail.vue";
